<template>
  <div class="dashboard-container">
    <side-bar />
    <div class="main-content">
      <!--Breadcrumbs and title embedded within below data page-->
      <div class="container">
        <partner-breadcrumbs />
      </div>

      <div class="tabs">
        <div class="tab-header">

          <button v-if="showConvHistoryTab" class="tab-button"
            @click="this.$router.push('/partner/conversation-history/voice')"
            :class="{ active: activeTab === 'conv-history' }">Conversation History</button>
          <!-- <button class="tab-button" @click="this.$router.push('/partner/view-bot')"
            :class="{ active: activeTab === 'bot-config' }">Bot Configuration</button> -->
          <button class="tab-button" @click="this.$router.push('/partner/analytics')"
            :class="{ active: activeTab === 'bot-analytics' }">Analytics</button>
        </div>
        <div class="tab-content">
          <div v-if="activeTab === 'conv-history'">
            <button class="back-btn" @click="this.$router.push('/partner/conversation-history/voice')">
              &lt; BACK
            </button>
            <ConversationTranscript />
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import SideBar from './SideBar.vue'
import ConversationTranscript from '../vuetify/ConversationTranscript.vue'
import PartnerBreadcrumbs from './PartnerBreadcrumbs.vue'
import { medicalBotIds } from "@/config/medicalBots.js"


export default {
  name: 'ViewConversationTranscript',
  components: {
    SideBar,
    ConversationTranscript,
    PartnerBreadcrumbs
  },
  data() {
    return {
      activeTab: 'conv-history', // Default active tab
      showConvHistoryTab: true
    }
  },
  mounted() {
    const botId = localStorage.getItem("botID") || '';
    if (medicalBotIds.includes(botId)) {
      this.showConvHistoryTab = false;
    }
  }
}
</script>
<style lang="css" scoped>
button.back-btn {
  flex: 1;
  display: inline-block;
  margin-top: 20px;
  margin-bottom: 40px;
  border-radius: 20px;
  background-color: black;
  color: white;
  box-shadow: 4px 3px 8px rgba(0, 0, 0, 0.1);
  font-size: 16px;
}

button.back-btn:hover {
  color: black;
  background-color: #FE602F;
  font-weight: normal;
}
</style>
